<template>
  <div>

    <el-container style="height: 100vh;">
        <el-menu background-color="#191919" class="el-menu-vertical-demo"  :default-openeds="['1']" :collapse="isCollapse" unique-opened="true">
          <button class="menu-btn" @click="isCollapse === false ? isCollapse = true : isCollapse = false" >
          <i class="el-icon-menu" style="color: #fff"></i>
          </button>
          <el-submenu
            v-for="modulo in modulos"
            :key="modulo.id"
            :index="modulo.id"
          >
            <template slot="title">
              <span style="color: #fff">{{ modulo.name }} </span>
            </template>
            <el-menu-item-group
              v-for="licao in modulo.lessons"
              :key="licao.id"
              style="background-color: #191919"
            >
              <template slot="title">
                <span style="color: #fff">{{ licao.name }} </span>
              </template>
              <el-menu-item  :index="`${modulo.id + '-'+licao.id}`" style="color: #eee;" background-color="#191919" >
              <span> <input type="checkbox"> {{licao.title}}</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>

      <el-container>
        <el-header style="text-align: right; font-size: 12px">
          <!-- <span>Tom</span> -->
        </el-header>

        <el-main style="width: 90%;margin: auto;">
          <h2>Seja Bem Vindo ao seu Curso</h2>
          <!-- <div class="video" style="width: 90%;">
            <video
              width="100%"
              autoplay
              controls
              src="http://localhost:3000/videos/1/Ponteiros-Ponteiro-Simples-Apenas-video-teste.mp4"
            ></video>
            <div
              style="text-align: center; font-size: 1.5rem; font-weight: 550;"
            >
              
            </div>
          </div> -->
          <!--CardLearning -->
          <div class="CardLearning" style="width: inherit;">
            <h2>Modulos / Lições</h2>
             <button class="btn" @click="()=>{return this.$router.push('/course/16/17/Curso-Javascript')}" >Continuar Progresso</button>
            <div
              class="CARD_MODULE_LEASSONS"
              v-for="modulo in modulos"
              :key="modulo.id"
            >
              <ul style="list-style-position: inside;">
                <h1>{{ modulo.name }} - Realizar Tao coisa</h1>
                <li v-for="licao in modulo.lessons" :key="licao.id">
                  <span v-if="modulo.lessons.length > 0">{{
                    licao.title
                  }}</span>
                </li>
              </ul>
              <h2
                style="padding: 4px;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  width: 150px;"
              >
                12h
                <el-progress
                  style="font-size: 18px !important;font-weight: 600;"
                  width="90"
                  type="dashboard"
                  color="#1989fa"
                  :percentage="modulo.progress"
                  stroke-width="8"
                  stroke-linecap="square"
                ></el-progress
                >
              </h2>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import axios from 'axios';
let id = 1;
export default {
  data() {
    return {
      myHeaders: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
      courseName: '',
      userId: '',
      linkUpload: `${process.env.VUE_APP_API}/upload/`,
      dataObjects: {
        pathName: '',
      },
      lessonName: '',
      modulos: [],
      enabled: true,
      list: [
        { title: 'Exemple', name: 'Exemple', id, lessonTypes: '' },
        // { title: 'teste', name: '12121', id: id++ },
      ],
      dragging: false,
      tipoLicao: 'textarea',
      options: [
        {
          value: 'video',
          label: 'Video',
        },
        {
          value: 'texto',
          label: 'Texto',
        },
      ],
      fileList: [],
      isCollapse: false,
    };
  },
  async created() {
    const data = await this.getData();
    console.log(data);
    this.courseName = data.courses[0].name;
    this.userId = data.courses[0].userId;
    this.token = localStorage.getItem('token');
    data.modules.forEach(element => {
      this.modulos.push({ ...element });
    });
    console.log(this.modulos);

    // vendo progressol
    
    
    this.modulos.map(modulo => {
      let contTotal = 0;
      let contDone = 0;
      modulo.lessons.forEach(licao => {
        contTotal++;
        if(licao.done){
          contDone++;
        }
      });
      modulo.progress = ((contDone/contTotal)*100).toFixed(2);
      console.log(`Progresso do modulo ${modulo.name} - ${(contDone/contTotal)*100}`);
    });
  },

  methods: {
    async getData() {
      const courseId = this.$route.params.courseId || 17;
      // const moduleId = this.$route.params.moduleId;
      const response = await axios.get(
        process.env.VUE_APP_API + '/courses/' + courseId
      );
      return response.data;
    },
    linkVideo(userId, moduleName, lessonName) {
      //localhost:3000/videos/1/Ponteiros-Ponteiro-Simples-Apenas-video-teste.mp4
      let newModule = moduleName.split(' ').join('-');
      let newlesson = lessonName.split(' ').join('-');
      return (
        'http://localhost:3000/videos/' +
        userId +
        '/' +
        newModule +
        newlesson +
        'Apenas-video-teste.mp4'
      );
    },
  },
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  text-transform: capitalize;
  font-family: 'Poppins', sans-serif;
  font-weight: normal;
}
body {
  background: #eee;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 360px;
    min-height: 400px;
  }
  .menu-btn{
    background: none;
    width: 100%;
    border: none;
    font-size: 1.5rem;
    text-align: center;
    margin: 0 auto;
  }
  .btn{
    background: none;
    border: none;
    font-size: 1.2rem;
    text-align: center;
    margin: 0 auto;
    cursor: pointer;
    color: #1989fa;
  }
/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 7px;
}

::-webkit-scrollbar-track {
  background-color: #ebebeb;
  -webkit-border-radius: 10px;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: #6d6d6d;
}
.el-progress--circle .el-progress__text,
.el-progress--dashboard .el-progress__text {
  font-size: 20px !important;
}
.CARD_MODULE_LEASSONS {
  margin: 10px auto;
  background-color: #fff;
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 2px solid rgb(0 0 0 / 36%);
  border-radius: 10px;
  padding: 10px;
}

.container {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 15px;
  align-items: flex-start;
  padding: 5px 5%; /* padding: 5px 5px 5px 5px; */
}


.container .main-video video {
  width: 100%;
  border-radius: 5px;
}

.container .main-video .title {
  color: #333;
  font-size: 23px;
  padding-top: 15px;
  padding-bottom: 15px;
}
.container .video-list {
  background: #fff;
  border-radius: 5px;
  /* height: 520px; */
  overflow-y: scroll;
}

.container .video-list::-webkit-scrollbar {
  width: 7px;
}
.container .video-list::-webkit-scrollbar-track {
  background: #ccc;
  border-radius: 50px;
}
.container .video-list::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 50px;
}

.container .video-list .vid video {
  width: 100px;
  border-radius: 5px;
}

.container .video-list .vid {
  display: flex;
  align-items: center;
  gap: 15px;
  background: #f7f7f7;
  border-radius: 5px;
  margin: 10px;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
